import { displayDate } from "../../helpers";

const defaultFields = () => ({
	items: [],
	title: "",
	number: "",
	customer: {name: "", id: 0, company: {name: "", id: 0}},
	discount: 0,
	terms: "",
	date: displayDate(),
	expired_at: displayDate(() => {
		let curDate = new Date();
		curDate.setMonth(curDate.getMonth() + 1);
		return curDate;
	})
})

const defaultItemFields = () => ({
	name: "",
	description: "",
	qty: "",
	price: 0
})

const defaultErrors = () => ({
	payment_term: null,
	customer_id: null,
})

const getBasePrice = async () => {
	try {
		let response = await axios.get('/setting');
		response = response.data.data.recommended_base_price;
		return response === null ? 0 : response;
	} catch (e) {
		return e;
	}
}

export {
	defaultFields, getBasePrice, defaultItemFields, defaultErrors
}
